import { render } from "./popBg.vue?vue&type=template&id=39fd091e&scoped=true"
import script from "./popBg.vue?vue&type=script&lang=js"
export * from "./popBg.vue?vue&type=script&lang=js"

import "./popBg.vue?vue&type=style&index=0&id=39fd091e&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fd091e"]])

export default __exports__